import {State, Action, StateContext, Selector} from '@ngxs/store';
import { ErDashBoardData } from './erdashboard.action';
import { Injectable } from '@angular/core';


const defaultState ={

  patientFilter:null,
nurseStation:null,
Nurse:null,
selectReferTime:null,
startDateEndDate:null,
pageSize:null




}

@State<any>({
  name: 'ErDashBoardData',
  defaults: defaultState
})
@Injectable()

export class DashBoardDataState{

patientFilter:any;
nurseStation:any;
Nurse:any;
selectReferTime:any
startDateEndDate:any
myListChecked:any
toDate:any
_filterPatientControl:any 
filterIndex:any
fromDate:any
pagination:any

  @Selector()
  static getDashboardFilterData(state: any) {
    return state;
  }

@Action(ErDashBoardData)
ErDashBoardData({getState, patchState}: StateContext<any>, {payload}: any) {
// console.log(payload,'payload');
    const state = getState();

    if(payload.Name==='ERPateint'){
    patchState({
         patientFilter:payload.patientFilter,
         nurseStation:payload.nurseStation,
         Nurse:payload.Nurse,
         selectReferTime:payload.selectReferTime,
         startDateEndDate:payload.startDateEndDate,
         myListChecked:payload.myListChecked,
         toDate:payload.toDate,
         fromDate:payload.fromDate,
         pageSize:payload.pageSize
        

    });
  
  }
    if(payload.Name==='InPateint'){
    patchState({
         inpatientFilter:payload.inpatientFilter,
         innurseStation:payload.innurseStation,
         inNurse:payload.inNurse,
         inselectReferTime:payload.inselectReferTime,
         instartDate:payload.instartDate,
         inmyListChecked:payload.inmyListChecked,
         inendDate:payload.inendDate,
         ipPageSize:payload.ipPageSize
    });
 
  }

    if(payload.Name==='Out Pateint'){
      patchState({
        _filterPatientControl:payload._filterPatientControl,
        filterIndex:payload.filterIndex,
        opfromDate:payload.opfromDate,
        optoDate:payload.optoDate,
        opPageSize:payload.opPageSize
        // Name:'Out Pateint'

   });

    }
    if(payload.Name==='Nursedashboard'){

      const nurseStationIds = payload.nurseStationIds.includes('0') 
      ? [0]
      : payload.nurseStationIds;
      patchState({
        nurseStationIds: nurseStationIds,
        selectedColumns:payload.selectedColumns,
        myListStatus:payload.myListStatus,
        loadingTime:payload.loadingTime,

   });

    }

}


}
